import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormControl, Validators, FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router, RoutesRecognized } from '@angular/router';
import { CoreTaskDataService } from '../core-task-data.service';
import { Subscription } from 'rxjs/Subscription';
import { CoreTaskData } from '../coreTaskData';
import { ExaminationComponent } from '../examination/examination.component';
import { SemsoSnackbarService } from 'app/semso-snackbar.service';
import { StateService } from 'app/state.service';
import { BreadcrumbService } from '../../breadcrumb/breadcrumb.service';

@Component({
  selector: 'app-data-check',
  templateUrl: './data-check.component.html',
  styleUrls: ['./data-check.component.scss']
})
export class DataCheckComponent implements OnInit {
  public datacheckForm: FormGroup;
  private routeSubscription: Subscription;
  private coreTaskSubsciption: Subscription;
  private model: CoreTaskData = new CoreTaskData();
  private coreTaskId;

  private dataRetrievalError: Subscription;
  private dataPostError: Subscription;

  constructor(private fb: FormBuilder, private route: ActivatedRoute, private router: Router,
    private breadcrumbService: BreadcrumbService, private coreTaskDataService: CoreTaskDataService,
    private snackbar: SemsoSnackbarService, private stateService: StateService) { }

  ngOnInit() {
    this.breadcrumbService.workProcessCode = 'Gegevens controle';
    this.route.parent.params.subscribe(data => {
      this.coreTaskId = data['examinationId'];
      this.coreTaskDataService.getCoreTaskData(data['examinationId']).subscribe(coreTaskData => {
        this.model = coreTaskData;
        this.datacheckForm = this.fb.group({
          studentNumber: [{ value: this.model.studentnummer, disabled: true }, [Validators.required]],
          studentName: [{ value: this.model.studentnaam, disabled: true }, [Validators.required]],
          regionalTrainingCenterContact: [this.model.roC_Contactpersoon, [Validators.required]],
          professionalPracticeCompany: [this.model.bpV_Bedrijf, [Validators.required]],
          professionalPracticeContact: [this.model.bpV_Contactpersoon, [Validators.required]],
          firstAssessor: [{ value: this.model.beoordelaar1_Naam, disabled: true }, [Validators.required]],
          secondAssessor: [this.model.beoordelaar2_Naam, [Validators.required]],
        });
        this.stateService.datacheck = this.datacheckForm.valid;

        this.datacheckForm.valueChanges.subscribe(() => {
          if (this.datacheckForm.dirty) {
            this.stateService.datacheck = false;
          }
        });
      });
    });

    this.dataPostError = this.coreTaskDataService.dataPostError$.subscribe(data => {
      this.snackbar.error('Probleem bij het versturen van de data');
    });

    this.dataRetrievalError = this.coreTaskDataService.dataRetrievalError$.subscribe(data => {
      this.snackbar.error('Probleem bij het ophalen van de data');
    });
  };

  supplementData(startsWith) {
    this.coreTaskDataService.getCoreTaskDataCache()
      .subscribe(cache => {
        let properties = Object.getOwnPropertyNames(this.model);
        properties.forEach(prop => {
          startsWith.forEach(needle => {
            if (prop.startsWith(needle)) {
              var value = this.model[prop];
              if (value == null || value == '') {
                value = cache[prop];
              }
              this.model[prop] = value;
            }
          })
        });
      });
  }

  submitForm(value) {
    this.coreTaskDataService.postCoreTaskData(this.coreTaskId, this.model).subscribe(data => {
      this.stateService.datacheck = true;
      this.router.navigate(['../workprocess', this.stateService.getNextRoute('data-check')],
        { relativeTo: this.route, queryParamsHandling: 'merge' });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/examination/data-check/data-check.component.ts